import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { ClientSideSuspense } from "shared/components/common/client-side-suspense";

import { ContentItemHomeSuperSplashLivePrimaryV2 } from "scmp-app/components/content/content-item-render/variants/home-super-splash-live-primary-v2";
import type { superSplashLiveHomeV2LiveWidget$key } from "scmp-app/queries/__generated__/superSplashLiveHomeV2LiveWidget.graphql";

import {
  Container,
  Label,
  StyledHomeV2Timelines,
  StyledLoading,
  TimelineContainer,
} from "./styles";

type Props = {
  className?: string;
  reference: superSplashLiveHomeV2LiveWidget$key;
};

export const HomeV2SuperSplashLive: FunctionComponent<Props> = ({ className, reference }) => {
  const data = useFragment(
    graphql`
      fragment superSplashLiveHomeV2LiveWidget on LiveWidget {
        label
        relatedArticles {
          entityUuid
          urlAlias
          ...homeSuperSplashLivePrimaryV2ContentItemContent
        }
      }
    `,
    reference,
  );

  const label = data?.label;
  const [firstArticle] = data?.relatedArticles ?? [];
  const firstArticleEntityUuid = firstArticle?.entityUuid;
  const firstArticleUrlAlias = firstArticle?.urlAlias;

  return (
    <Container $hasLabel={!!label} className={className}>
      {label && <Label>{label}</Label>}
      {firstArticle && <ContentItemHomeSuperSplashLivePrimaryV2 reference={firstArticle} />}
      <TimelineContainer>
        <ClientSideSuspense fallback={<StyledLoading />}>
          {firstArticleEntityUuid && (
            <StyledHomeV2Timelines
              entityUuid={firstArticleEntityUuid}
              urlAlias={firstArticleUrlAlias}
            />
          )}
        </ClientSideSuspense>
      </TimelineContainer>
    </Container>
  );
};

HomeV2SuperSplashLive.displayName = "HomeV2SuperSplashLive";
